import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/depots/depots.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import DepotMap from "../maps/depotMap";
import renderHTML from "react-render-html";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";
import { searchSuggestionAPI, GeoCodeAPI } from "../../utils/mapapi";
class EditZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depotName: "",
      customers: [],
      depots: [],
      customerId: "",
      customerName: "",
      depotId: "default",
      name: "",
      address: "",
      duration: "",
      timeZoneArr: [],
      timeZoneName: "",
      description: "",
      error: false,
      timeZoneId: "",
      type: "",
      mapOverlay: "",
      id: "",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      lat: "",
      lng: "",
      customerError: false,
      nameError: false,
      descriptionError: false,
      timeZoneError: false,
      typeError: false,
      mapOverlayError: false,
      mapOverLay: "",
      dbCreated: "",
      dbUpdated: "",
      status: "",
    };
    this.circleLat = "";
    this.circleLng = "";
    this.circleRad = "";
    this.rectLat1 = "";
    this.rectLat2 = "";
    this.rectLng1 = "";
    this.rectLng2 = "";
    this.polygonArr = [];
    this.type = "";
  }
  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/POI/SelectPOI/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (response.status == "200") {
        this.setData(response.data);
      }
      console.log("response ", response.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      this.props.setLoadingPageAction(false);
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
    }
    else{
      console.log("no api called");
    }

    this.getTimeZone();
  }

  getDepotList = async (id) => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/DepotByCustomerId/${id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        let depotName = this.state.depotName;
        this.setState({ depots: response.data, depotName });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setData = (data) => {
    const {
      name,
      depotName,
      description,
      customerName,
      customerId,
      timeZonesId,
      timeZoneCity,
      overlay,
      id,
      duration,
      status,
      address,
      dbCreated,
      dbUpdated,
      depotId,
    } = data;
    this.setGraph(JSON.parse(overlay));
    this.setState({
      name,
      description,
      customerName,
      timeZoneId: timeZonesId,
      timeZoneCity,
      timeZoneName: timeZoneCity,
      customerId,
      mapOverlay: overlay,
      id,
      duration,
      type: this.typeCheck(status),
      address,
      dbCreated,
      depotName,
      dbUpdated,
      status: this.typeCheck(status),
      depotId,
    });
  };

  typeCheck = (value) => {
    if (value == 1) {
      return "Active";
    }
    return "Disable";
  };

  handleDepot = (e) => {
    if (e.target.value === "default") {
      this.setState({ depotError: true });
    }

    this.setState({ depotId: e.target.value, depotError: false });
    console.log(e.target.value);
  };

  setGraph = (data) => {
    switch (data.type) {
      case "circle":
        this.type = data.type;
        this.circleLat = data.lat;
        this.circleLng = data.lng;
        this.circleRad = data.rad;
        this.createMapOverLay();
        break;
      case "polygon":
        this.type = data.type;
        this.polygonArr = this.handleArrRecreation(data.arr);
        this.createMapOverLay();
        break;
      case "rectangle":
        this.type = data.type;
        this.rectLat1 = data.lat1;
        this.rectLat2 = data.lat2;
        this.rectLng1 = data.lng1;
        this.rectLng2 = data.lng2;
        this.createMapOverLay();
        break;
      default: break;
    }
  };

  createMapOverLay = () => {
    var mapOverlayObj = {};

    switch (this.type) {
      case "circle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });

        break;
      case "polygon":
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.polygonArr;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });

        break;
      case "rectangle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });
        
        break;
      default: break;
    }
  };

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
        // this.getDepotList(response.data[0].id);
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getTimeZone = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "") {
      this.setState({ timeZoneError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({
          timeZoneId: time.timeZonesId,
          timeZoneName: time.timeZoneCity,
        });
      }
    });
  };

  handleType = (evt) => {
    if (evt.target.value == "") {
      this.setState({ typeError: true });
    } else {
      this.setState({ nameError: false });
    }
    // let status = "";
    // if (evt.target.value == "Active") {
    //   status = 1;
    // } else {
    //   status = 0;
    // }
    this.setState({ type: evt.target.value, status: evt.target.value });
  };

  // handleCancel = () =>{
  //   this.props.history.push("/customers");
  // }

  handleCustomer = (evt) => {
    if (evt.target.value == "") {
      this.setState({ customerError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.customers.forEach((customer) => {
      if (customer.name === evt.target.value) {
        this.setState({ customerId: customer.id, customerName: customer.name });
        //  this.getDepotList(customer.id);
      }
    });
  };
  handleAddress = (e) => {
    this.setState({ address: e.target.value });
  };
  handleDuration = (e) => {
    this.setState({ duration: e.target.value });
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleArrCreation = (data) => {
    // var dataNew = [
    //   -22.67253064091629,
    //   127.47044921875,
    //   0,
    //   -22.87453064091629,
    //   127.33044921875,
    //   0,
    //   -23.052530640916288,
    //   127.52744921875001,
    //   0,
    //   -22.98153064091629,
    //   127.74844921875001,
    //   0,
    //   -22.74253064091629,
    //   127.74844921875001,
    //   0,
    // ];
    var i;
    for (i = 0; i < data.length; i++) {
      if (data[i] == 0) data.splice(i, 1);
    }
    var requiredArr = [];
    for (i = 0; i < data.length; i = i + 2) {
      const coordinateObj = {
        lat: data[i],
        lng: data[i + 1],
      };
      requiredArr.push(coordinateObj);
    }

    return requiredArr;
  };

  handleArrRecreation = (data) => {
    // var dataNew = [
    //   {
    //     lat: -22.67253064091629,
    //     lng: 127.47044921875,
    //   },
    //   {
    //     lat: -22.87453064091629,
    //     lng: 127.33044921875,
    //   },
    //   {
    //     lat: -23.052530640916288,
    //     lng: 127.52744921875001,
    //   },
    //   {
    //     lat: -22.98153064091629,
    //     lng: 127.74844921875001,
    //   },
    //   {
    //     lat: -22.74253064091629,
    //     lng: 127.74844921875001,
    //   },
    // ];

    var requiredArr = [];
    data.forEach((element) => {
      requiredArr.push(element.lat);
      requiredArr.push(element.lng);
      requiredArr.push(0);
    });

    return requiredArr;
  };

  handleCircleCreate = (data) => {
    this.circleLat = data.lat;
    this.circleLng = data.lng;
    this.circleRad = data.rad;
    this.type = "circle";
    console.log("oook");
    this.createMapOverLay();
  };

  handlePolygonCreate = (data) => {
    this.polygonArr = data;
    this.type = "polygon";
    this.createMapOverLay();
  };

  handleRectangleCreate = (data) => {
    this.type = "rectangle";
    this.rectLat1 = data.lat1;
    this.rectLat2 = data.lat2;
    this.rectLng1 = data.lng1;
    this.rectLng2 = data.lng2;
    this.createMapOverLay();
  };

  handleCreate = async () => {
    const { name, description, customerId, id } = this.state;
    const obb = {
      Id: id,
      CustomerId: customerId,
      DepotId: this.state.depotId,
      Name: name,
      Address: this.state.address,
      Duration: this.state.duration,
      Description: description,
      Status: this.state.status === "Active" ? 1 : 0,
      DbCreated: this.state.dbCreated,
      DbUpdated: this.state.dbUpdated,
    };

    var MapOverlayObj = {};
    switch (this.type) {
      case "circle":
        MapOverlayObj.type = this.type;
        MapOverlayObj.lat = this.circleLat;
        MapOverlayObj.lng = this.circleLng;
        MapOverlayObj.rad = this.circleRad;

        obb.Overlay = JSON.stringify(MapOverlayObj);

        break;
      case "polygon":
        MapOverlayObj.type = this.type;
        MapOverlayObj.arr = this.handleArrCreation(this.polygonArr);
        obb.Overlay = JSON.stringify(MapOverlayObj);

        break;
      case "rectangle":
        MapOverlayObj.type = this.type;
        MapOverlayObj.north = this.rectLat1;
        MapOverlayObj.south = this.rectLat2;
        MapOverlayObj.west = this.rectLng1;
        MapOverlayObj.east = this.rectLng2;

        obb.Overlay = JSON.stringify(MapOverlayObj);

        break;
      default: break;
    }

    if (name && customerId) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(`${apiHost}/api/POI/UpdatePOI`, obb, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status == "200") {
          // this.props.history.push("/zones");
          this.props.history.goBack();
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = (obj) => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
    if (!this.state.type) {
      this.setState({ typeError: true });
    }
    if (!this.state.timeZoneId) {
      this.setState({ timeZoneError: true });
    }
    if (!obj) {
      this.setState({ mapOverlayError: true });
    }
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  // Map search and suggestions starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

  handleSearch = async () => {
    try {
      console.log("searec1", this.state.searchText);
        const { lat, lng } = await GeoCodeAPI(this.state.searchText);
        if (lat !== 0 && lng !== 0) {
        this.setState({
            lat: lat,
            lng: lng,
        });
      } else {
        this.setState({ errorSearch: true });
        setTimeout(() => {
          this.setState({ errorSearch: false });
        }, 1000);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleSearchSuggestion = async (query) => {
    if (query != "") {
      this.setState({ suggestionVisibility: false });
    }
    this.setState({ suggestionVisibility: true });
      try {
          const items = await searchSuggestionAPI(query);
          this.setState({ suggestions: items });
      } catch (e) {
          console.log(e);
      }
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
  handleSuggestionClick = async (place) => {
    var nwlocation = place.replace("<b>", "");
    var location = nwlocation.replace("</b>", "");

    this.setState({ searchText: location, suggestionVisibility: false });
    try {
      console.log("searecyy", location);
        const { lat, lng } = await GeoCodeAPI(location);
        if (lat !== 0 && lng !== 0) {
        this.setState({
            lat: lat,
            lng: lng,
        });
      } else {
        this.setState({ errorSearch: true });
        setTimeout(() => {
          this.setState({ errorSearch: false });
        }, 1000);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  // Map search and suggestions ends here

  render() {
    const {
      customerName,
      timeZoneName,
      type,
      name,
      description,
      mapOverlay,
      lat,
      lng,
      customerError,
      nameError,
      typeError,
      mapOverlayError,
      dbUpdated,
      dbCreated,
    } = this.state;
    console.log("overlay point", mapOverlay);
    console.log("timeZoneName", timeZoneName);
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Edit Point Of Interest </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Edit Point Of Interest</h2>
              <hr />
              <div className="formGroup">
                <Form>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      Customer
                    </Form.Label>
                    <Col sm="4">
                      {/* <Form.Control as="select" onChange={this.handleCustomer} value={customerName}>
                    <option value="default">Select Customer</option>
                    {customers.map((customer,index)=>(
                      <option key={index}>{customer.name}</option>
                      ))}

                 </Form.Control> */}
                      <p className="detailsValue">{customerName}</p>
                      <p
                        style={
                          customerError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Customer field is required.
                      </p>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Name
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        onChange={this.handleName}
                        type="plaintext"
                        placeholder=""
                        value={name}
                      />
                      <p
                        style={
                          nameError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Name field is required.
                      </p>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Description
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        as="textarea"
                        rows="3"
                        onChange={this.handleDescription}
                        value={description}
                      />
                    </Col>
                  </Form.Group>
                  {/*
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      TimeZone
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        as="select"
                        onChange={this.handleTimeZone}
                        value={timeZoneName}
                      >
                        <option value="default">Select TimeZone</option>
                        {timeZoneArr.map((timezone, index) => (
                          <option key={index}>{timezone.timeZoneCity}</option>
                        ))}
                      </Form.Control>
                      <p
                        style={
                          timeZoneError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The TimeZone field is required.
                      </p>
                    </Col>
                  </Form.Group> */}
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      Overlay
                    </Form.Label>
                    <Col sm="10">
                      <div className="containerMapDepot">
                        <DepotMap
                          onCircleCreate={this.handleCircleCreate}
                          onPolygonCreate={this.handlePolygonCreate}
                          onRectangleCreate={this.handleRectangleCreate}
                          mapOverlay={mapOverlay}
                          lat={lat}
                          lng={lng}
                        />
                        <div className="overlaySearch">
                          <Col sm="12" className="inputSuggestions">
                            <Form.Control
                              value={this.state.searchText}
                              onChange={(e) =>
                                this.handleLocationChange(e.target.value)
                              }
                              onKeyPress={(e) => this.handleKeyPress(e)}
                              autocomplete="off"
                              type="plaintext"
                              placeholder="Search location"
                            />
                            {this.state.suggestionVisibility && (
                              <ul>
                                {this.state.suggestions &&
                                  this.state.suggestions.map((item, index) => {
                                    return (
                                      <li
                                            key={item.address.label}
                                        onClick={() =>
                                            this.handleSuggestionClick(item.address.label)
                                        }
                                      >
                                            {renderHTML(item.address.label)}
                                      </li>
                                    );
                                  })}
                              </ul>
                            )}
                            <p
                              style={
                                mapOverlayError
                                  ? { color: "#a94442", fontSize: "14px" }
                                  : { display: "none" }
                              }
                            >
                              The Map field is required.
                            </p>
                          </Col>
                        </div>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Debug Only
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        onChange={this.handleName}
                        as="textarea"
                        value={this.state.mapOverLay}
                        disabled
                        placeholder=""
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      Status
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        as="select"
                        onChange={(e) => this.handleType(e)}
                        value={type}
                      >
                        {/* <option value="default">Select Type</option> */}

                        <option>Active</option>
                        <option>Disable</option>
                      </Form.Control>
                      <p
                        style={
                          typeError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Type field is required.
                      </p>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Duration (minutes)
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        onChange={this.handleDuration}
                        type="number"
                        placeholder=""
                        value={this.state.duration}
                      />
                      <br />
                      <p
                        style={{
                          position: "relative",
                          top: "-15px",
                          padding: "0px",
                        }}
                      >
                        Estimated duration of time spent at this location. This
                        value is used as the suggested default when used as a{" "}
                        <i>stop</i> in the Run Sheet feature.
                      </p>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Address
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        onChange={this.handleAddress}
                        type="plaintext"
                        placeholder=""
                        value={this.state.address}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Updated
                    </Form.Label>
                    <Col sm="4">
                      <p
                        className="detailsValue"
                        style={{ position: "relative", top: "8px" }}
                      >
                        {utcToLocal(dbUpdated)}
                      </p>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Created
                    </Form.Label>
                    <Col sm="4">
                      <p
                        className="detailsValue"
                        style={{ position: "relative", top: "8px" }}
                      >
                        {utcToLocal(dbCreated)}
                      </p>
                    </Col>
                  </Form.Group>
                  {/* <Form.Group as={Row} controlId="formPlainAddress">
               <Form.Label  column sm="2">Address</Form.Label>
               <Col sm="4">
               <div>Position (<span>{lat}, {lng})</span></div>
               <div>{address}</div>
               </Col>
              </Form.Group>  */}
                  <Row>
                    <Col sm="2"></Col>
                    <Col sm="9">
                      <Button variant="light" onClick={this.handleBack}>
                        Back to List
                      </Button>
                      <Button variant="primary" onClick={this.handleCreate}>
                        Save
                      </Button>
                    </Col>
                  </Row>
                  {this.state.error && (
                    <Row>
                      <Col sm="2"></Col>
                      <Col sm="9">
                        <p className="error-text">
                          Please fill all the Required fields
                        </p>
                      </Col>
                    </Row>
                  )}
                  <br />
                  <br /> <br />
                  <br /> <br />
                  <br />
                </Form>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditZone);
